import type {ComponentType} from 'react'

function isRoutablePageExport(name: string, value: unknown): value is ComponentType<any> {
  if (typeof value !== 'function') return false
  if (!/^[A-Z][a-zA-Z0-9]*$/.test(name)) return false
  return name.endsWith('Page')
}

/**
 * src/app/pages altındaki .tsx dosyalarından *Page adlı React bileşen export'larını toplar.
 * Menü API'deki componentName bu export adıyla birebir eşleşmeli (örn. CarPage, MaintenancePage).
 *
 * Yeni ekran: PrivateRoutes'a dokunmadan pages altına dosya ekleyin; export adı menüdeki componentName olsun.
 * Dosya adı farklı olabilir (örn. ServiceMaintenancePage.tsx → export MaintenancePage).
 */
function buildPageComponentRegistry(): Record<string, ComponentType<any>> {
  const registry: Record<string, ComponentType<any>> = {}

  const context = require.context('../pages', true, /\.tsx$/)

  context.keys().forEach((key: string) => {
    if (key.includes('/_modals/')) return

    const mod = context(key) as Record<string, unknown>
    if (!mod || typeof mod !== 'object') return

    for (const exportName of Object.keys(mod)) {
      if (exportName === '__esModule') continue
      const val = mod[exportName]
      if (isRoutablePageExport(exportName, val)) {
        registry[exportName] = val
      }
    }

    const def = mod.default
    if (typeof def === 'function') {
      const fn = def as ComponentType<any> & {name?: string; displayName?: string}
      const inferred = fn.name || fn.displayName
      if (inferred && isRoutablePageExport(inferred, def)) {
        registry[inferred] = fn as ComponentType<any>
      }
    }
  })

  return registry
}

export const PAGE_COMPONENT_REGISTRY = buildPageComponentRegistry()
